import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: "detail" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "text-[20px] sm:text-[22px] font-semibold text-[#0f1f2e] tracking-tight leading-tight flex-1 min-w-0 truncate" }
const _hoisted_6 = { class: "flex items-center gap-2 pl-9 flex-wrap mb-3" }
const _hoisted_7 = { class: "text-[13px] text-[#7a9aaa]" }
const _hoisted_8 = { class: "text-[13px] text-[#7a9aaa]" }
const _hoisted_9 = {
  key: 0,
  class: "inline-flex items-center gap-1 text-[10px] font-medium text-[#7a9aaa] bg-slate-100 rounded-full px-2 py-0.5"
}
const _hoisted_10 = { class: "flex items-center gap-2 pl-9" }
const _hoisted_11 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_13 = { class: "flex gap-4" }
const _hoisted_14 = { class: "flex-shrink-0 w-[46px] rounded-xl overflow-hidden shadow-sm border border-black/10 text-center select-none self-start" }
const _hoisted_15 = { class: "bg-[#0f1f2e] text-white text-[9px] font-semibold uppercase tracking-wider py-[3px]" }
const _hoisted_16 = { class: "bg-white pt-1.5 pb-1 flex flex-col items-center" }
const _hoisted_17 = { class: "text-[22px] font-bold text-[#0f1f2e] leading-none" }
const _hoisted_18 = { class: "text-[8px] font-semibold uppercase tracking-wider text-[#7a9aaa] mt-0.5" }
const _hoisted_19 = { class: "flex-1 min-w-0 flex flex-col gap-2.5" }
const _hoisted_20 = { class: "flex items-center justify-between gap-3" }
const _hoisted_21 = { class: "text-[15px] font-semibold text-[#0f1f2e] tracking-tight leading-snug" }
const _hoisted_22 = {
  key: 0,
  class: "text-[12px] font-semibold text-[#9ab4c0] flex-shrink-0"
}
const _hoisted_23 = { class: "text-[14px] font-semibold" }
const _hoisted_24 = { class: "flex items-center gap-4 flex-wrap" }
const _hoisted_25 = { class: "flex items-center gap-1.5 text-[14px] font-medium text-[#3d5a6e]" }
const _hoisted_26 = { class: "flex items-center gap-1.5 text-[14px] text-[#3d5a6e]" }
const _hoisted_27 = { class: "font-semibold" }
const _hoisted_28 = {
  key: 0,
  class: "text-[#b0c4d4]"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "flex items-center gap-2 flex-wrap pt-2.5 border-t border-black/[0.06]"
}
const _hoisted_32 = ["href"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "rounded-[18px] border border-white/90 bg-white/60 backdrop-blur-2xl shadow-[0_2px_24px_rgba(0,0,0,0.05)] px-6 py-14 text-center"
}
const _hoisted_36 = { class: "text-[#7a9aaa] mb-3" }

import type { Group, Session } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupDetail',
  props: {
    group: {},
    sessions: {},
    loadingSessions: { type: Boolean },
    expandedSessionId: {},
    memberGroupIds: {},
    isLoggedIn: { type: Boolean },
    sessionLinkCopied: {},
    detailLinkCopied: { type: Boolean }
  },
  emits: ["back", "propose-session", "toggle-session", "expand-session", "share-session", "share-detail", "whatsapp-detail", "telegram-detail", "copy-detail"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const {
  t,
  getDiseaseLabel,
  formatDay,
  formatMonthAbbr,
  formatDayOfWeek,
  formatWeekdayTime,
  isSessionPast,
  isCallActive,
} = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "w-7 h-7 rounded-full flex items-center justify-center text-[#7a9aaa] hover:text-[#0f1f2e] hover:bg-black/5 transition flex-shrink-0",
          title: _unref(t)('back'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
          ], -1)
        ]))], 8, _hoisted_4),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.group.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getDiseaseLabel)(__props.group.diseaseKey)), 1),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-[#c0cdd4]" }, "·", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.group.memberCount) + " " + _toDisplayString(_unref(t)("members")), 1),
        (!__props.group.isPublic)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                width: "9",
                height: "9",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5"
              }, [
                _createElementVNode("rect", {
                  x: "3",
                  y: "11",
                  width: "18",
                  height: "11",
                  rx: "2"
                }),
                _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)("privateGroup")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "inline-flex items-center gap-1.5 text-[13px] font-semibold px-4 py-2 rounded-full bg-[#0f1f2e] text-white hover:opacity-85 transition",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('propose-session')))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("svg", {
            width: "11",
            height: "11",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "3",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("line", {
              x1: "12",
              y1: "5",
              x2: "12",
              y2: "19"
            }),
            _createElementVNode("line", {
              x1: "5",
              y1: "12",
              x2: "19",
              y2: "12"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)("proposeSession")), 1)
        ]),
        _createElementVNode("button", {
          class: "inline-flex items-center gap-1.5 text-[13px] font-medium px-4 py-2 rounded-full bg-[#4885d0] text-white hover:opacity-85 transition",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('share-detail')))
        }, [
          _cache[8] || (_cache[8] = _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18\" cy=\"5\" r=\"3\"></circle><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"19\" r=\"3\"></circle><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"></line><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"></line></svg>", 1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)("inviteToGroup")), 1)
        ])
      ])
    ]),
    (__props.loadingSessions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "w-6 h-6 rounded-full border-2 border-[#0f1f2e] border-t-transparent animate-spin" }, null, -1)
        ]))]))
      : (__props.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sessions, (session) => {
              return (_openBlock(), _createElementBlock("div", {
                key: session.id,
                class: _normalizeClass(["px-5 py-4 rounded-2xl border backdrop-blur shadow-[0_1px_8px_rgba(0,0,0,0.04)]", 
          session.status === 'cancelled' || _unref(isSessionPast)(session.dateTime)
            ? 'opacity-50 border-black/5 bg-white/40'
            : 'border-white/90 bg-white/70'
        ])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(formatDayOfWeek)(session.dateTime)), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(formatDay)(session.dateTime)), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formatMonthAbbr)(session.dateTime)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatWeekdayTime)(session.dateTime)), 1),
                      (_unref(isSessionPast)(session.dateTime))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(t)("sessionPast")), 1))
                        : (session.status !== 'open')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["flex items-center gap-1.5 flex-shrink-0", 
                  session.status === 'confirmed'
                    ? 'text-[#1a3a6e]'
                    : 'text-slate-400'
                ])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["w-[7px] h-[7px] rounded-full flex-shrink-0", 
                    session.status === 'confirmed'
                      ? 'bg-[#9dc0fd]'
                      : 'bg-slate-300'
                  ])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(session.status === "confirmed"
                      ? _unref(t)("sessionConfirmed")
                      : _unref(t)("sessionCancelled")), 1)
                            ], 2))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, [
                        _cache[10] || (_cache[10] = _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "8",
                            r: "4"
                          }),
                          _createElementVNode("path", { d: "M4 20c0-4 3.6-7 8-7s8 3 8 7" })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(session.hostName), 1)
                      ]),
                      _createElementVNode("span", _hoisted_26, [
                        _cache[11] || (_cache[11] = _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path></svg>", 1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(session.attendeeCount), 1),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("attendees")) + " ", 1),
                        (session.status === 'open')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "· " + _toDisplayString(_unref(t)("neededToConfirm")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (session.maxAttendees != null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-[12px] font-semibold", session.spotsLeft === 0
                  ? 'bg-red-50 text-red-500'
                  : session.spotsLeft != null && session.spotsLeft <= 3
                    ? 'bg-amber-50 text-amber-600'
                    : 'bg-slate-100 text-[#3d5a6e]'])
                          }, _toDisplayString(session.spotsLeft === 0 ? _unref(t)("sessionFull") : `${session.attendeeCount} / ${session.maxAttendees}`), 3))
                        : _createCommentVNode("", true)
                    ]),
                    (session.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["text-[13.5px] text-[#3d5a6e] leading-relaxed", 
                  __props.expandedSessionId !== session.id ? 'line-clamp-2' : ''
                ])
                          }, _toDisplayString(session.description), 3),
                          (session.description.length > 100)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "text-[12px] font-semibold text-[#9dc0fd] hover:text-[#1a3a6e] transition mt-0.5",
                                onClick: ($event: any) => (emit('expand-session', session.id))
                              }, _toDisplayString(__props.expandedSessionId === session.id
                    ? _unref(t)("viewLess")
                    : _unref(t)("viewMore")), 9, _hoisted_30))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (
                session.status !== 'cancelled' &&
                !_unref(isSessionPast)(session.dateTime)
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (
                  session.status === 'confirmed' &&
                  session.jitsiLink &&
                  session.isAttending &&
                  _unref(isCallActive)(session.dateTime)
                )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `/session/${session.accessSlug ?? session.id}`,
                                target: "_blank",
                                class: "inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#0f1f2e] bg-[#9dc0fd] px-4 py-2 rounded-full hover:opacity-85 transition"
                              }, [
                                _cache[12] || (_cache[12] = _createElementVNode("svg", {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5"
                                }, [
                                  _createElementVNode("polygon", { points: "23 7 16 12 23 17" }),
                                  _createElementVNode("rect", {
                                    x: "1",
                                    y: "5",
                                    width: "15",
                                    height: "14",
                                    rx: "2"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("joinCall")), 1)
                              ], 8, _hoisted_32))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "inline-flex items-center gap-1.5 text-[13px] font-medium px-3.5 py-2 rounded-full bg-[#4885d0] text-white hover:opacity-85 transition",
                            onClick: ($event: any) => (emit('share-session', session))
                          }, [
                            _cache[13] || (_cache[13] = _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"18\" cy=\"5\" r=\"3\"></circle><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"19\" r=\"3\"></circle><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"></line><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"></line></svg>", 1)),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("invitePeople")), 1)
                          ], 8, _hoisted_33),
                          _createElementVNode("button", {
                            class: _normalizeClass(["ml-auto text-[13px] font-semibold px-4 py-2 rounded-full transition whitespace-nowrap", 
                  session.isAttending
                    ? 'border border-red-200 text-red-400 hover:border-red-300 hover:bg-red-50'
                    : 'bg-[#0f1f2e] text-white hover:opacity-85'
                ]),
                            onClick: ($event: any) => (emit('toggle-session', session))
                          }, _toDisplayString(session.isAttending ? _unref(t)("unsignUp") : _unref(t)("signUp")), 11, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-4\"><svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#9ab4c0\" stroke-width=\"1.5\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"></rect><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line></svg></div>", 1)),
            _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)("noSessions")), 1),
            _createElementVNode("button", {
              class: "font-semibold text-[#0f1f2e] underline hover:no-underline transition",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('propose-session')))
            }, _toDisplayString(_unref(t)("proposeFirst")), 1)
          ]))
  ]))
}
}

})